import { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Container from "./components/Container";
import Grid from "./components/Grid";
import Field from "./components/Field";
import Button from "./components/Button";
import ProviderCard from "./components/ProviderCard";
import EmptyState from "./components/EmptyState";
import { CATEGORIES } from "./categories";
import { showService } from "./api";
import styles from "./pages/Results.module.css";

const labelFor = (value) => CATEGORIES.find((c) => c.value === value)?.label || value;

export default function ShowServices() {
  const history = useHistory();
  const category = localStorage.getItem("name") || "";
  const [pincode, setPincode] = useState(localStorage.getItem("pincode") || "");
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const fetchServices = useCallback(async () => {
    try {
      const response = await showService({ service_category: category, pincode });
      setRows(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.log(error);
      setRows([]);
    } finally {
      setLoaded(true);
    }
  }, [category, pincode]);

  useEffect(() => {
    fetchServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const providers = rows.filter((r) => r && r.uname);

  return (
    <div>
      <Nav />
      <main className={styles.page}>
        <Container>
          <div className={styles.head}>
            <h1 className={styles.title}>{labelFor(category)} providers</h1>
            <p className={styles.muted}>Service pros listed in your area.</p>
          </div>

          <form
            className={styles.searchWrap}
            onSubmit={(e) => {
              e.preventDefault();
              fetchServices();
            }}
            style={{ display: "flex", gap: "var(--s3)", alignItems: "end" }}
          >
            <Field id="pincode" label="Filter by pincode" value={pincode}
                   onChange={(e) => setPincode(e.target.value)} placeholder="e.g. 400001" />
            <Button type="submit">Search</Button>
          </form>

          {providers.length > 0 ? (
            <Grid min="260px">
              {providers.map((p, i) => (
                <ProviderCard
                  key={`${p.uname}-${i}`}
                  name={p.uname}
                  trade={labelFor(category)}
                  pincode={p.pincode}
                  onReview={() => {
                    localStorage.setItem("reviewname", p.uname);
                    history.push("/rateandcomment");
                  }}
                />
              ))}
            </Grid>
          ) : (
            loaded && (
              <EmptyState
                title="No pros yet"
                message="No providers listed for this service and pincode. Try a nearby pincode."
              />
            )
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
}
